// Utilities for CSRF tokens


const cookieRegex = /(?:^|;\s*)XSRF-TOKEN=([^;]*)/

export const CSRF_HEADER = 'x-csrf-token'


/**
 * Reads the current XSRF-TOKEN cookie value
 * @return {String|null}
 */
export function readCSRFCookie() {
  try {
    const match = document.cookie.match(cookieRegex)
    return match ? decodeURIComponent(match[1]) : null
  } catch(e) {
    return null
  }
}


export var isXHRPatchedForCSRF = false

/**
 * Patch XHR to always send the CSRF token in its headers. Invoke this from the app's
 * initialization code if it uses XHRs.
 */
export function patchXHRForCSRF() {
  if (!isXHRPatchedForCSRF && XMLHttpRequest) {
    const _origOpen = XMLHttpRequest.prototype.open
    XMLHttpRequest.prototype.open = function() {
      const result = _origOpen.apply(this, arguments)

      const token = readCSRFCookie()
      if (token) {
        this.setRequestHeader(CSRF_HEADER, token)
      }

      return result
    }
  }
  isXHRPatchedForCSRF = true
}
